/**
 * Eigenständige Seite "Passwort ändern" - über die Sidebar für JEDEN
 * eingeloggten Benutzer erreichbar, unabhängig von Rolle oder Berechtigungen
 * (siehe Sidebar.tsx: hartkodierter Eintrag außerhalb NAV_ITEMS/der
 * konfigurierbaren Rechteverwaltung, analog zu "Das Ende"). Nutzt dasselbe
 * Formular wie "Mein Profil" (siehe components/auth/ChangePasswordForm.tsx) -
 * der zugrunde liegende Endpunkt ändert serverseitig ausschließlich das
 * Passwort des eigenen, angemeldeten Kontos.
 */
import { Card, CardHeader } from "../components/ui/Card";
import { ChangePasswordForm } from "../components/auth/ChangePasswordForm";

export default function ChangePassword() {
  return (
    <div className="max-w-2xl mx-auto space-y-6">
      <Card>
        <CardHeader title="Passwort ändern" subtitle="Ändern Sie hier jederzeit Ihr eigenes Passwort." />
        <ChangePasswordForm />
      </Card>
    </div>
  );
}
